import { ApiPostRequest } from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Update Container Number',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/adm/conf',
      },
      {
        text: 'Report - Daily',
        href: '/adm/conf/change-container-no',
        active: true,
      },
    ],
    showmodal: false,
    export: 0,
    detail: false,
    form: {
      old_prefix: '',
      old_number: '',
      new_prefix: '',
      new_number: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeUpdateContNo(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async submitUpdate({ commit, state, dispatch }) {
    commit('changeUpdateContNo', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(
      `conf/container/update-container`,
      data.form,
      state.data.form
    );

    commit('changeUpdateContNo', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },
};
